/**
 * Static contact information constants
 * These values rarely change and don't need reactive updates
 */

const PHONE_MAIN = '069 42009-0';
const SUPPORT_EMAIL = 'hilfe@awo-care.org';

export const CONTACT_INFO = {
  // AWO Organization - Email addresses
  EMAIL_MAIN: 'post@awo-hs.org',

  // AWO Organization - Phone numbers
  PHONE_MAIN,

  // AWO Organization
  ORGANIZATION_NAME: 'AWO Perspektiven gGmbH',
  ORGANIZATION_SHORT_NAME: 'AWO Perspektiven gGmbH',

  // AWO Address
  ADDRESS_STREET: 'Kruppstraße 105',
  ADDRESS_POSTAL_CODE: '60388',
  ADDRESS_CITY: 'Frankfurt am Main',
  ADDRESS_FULL: 'Kruppstraße 105 60388 Frankfurt am Main',

  // AWO Website
  WEBSITE_URL:
    'https://www.awo-hs.org/awo-sozial/kinder-jugendliche/betreuung-an-schulen',
  WEBSITE_DISPLAY: 'www.awo-hs.org',

  // AWO People
  CEO_NAME: 'Ulrich Bauch, Andreas Pfeffer',
  BOARD_CHAIR_NAME: 'Christian Schüler',
  BOARD_CHAIR_TITLE: 'Christian Schüler (Vorsitzender)',
  DATA_PROTECTION_OFFICER_EMAIL: 'post@awo-hs.org',

  // AWO Legal/Registration
  COURT_NAME: 'Amtsgericht Frankfurt am Main',
  REGISTER_NUMBER: 'HRB 86826',
  TAX_NUMBER: '045 250 68343',
  TAX_ID: 'DE114236697',
  TAX_ID_FORMATTED: 'USt-IdNr.: DE114236697',

  // AWO Bank Details
  BANK_NAME: 'SozialBank',
  BANK_IBAN: 'DE59 3702 0500 0020 1414 11',
  BANK_BIC: 'BFSWDE33XXX',

  // Technical Provider (Stefan Landvogt IT Consulting)
  TECH_PROVIDER_COMPANY: 'Stefan Landvogt - IT Consulting',
  TECH_PROVIDER_NAME: 'Stefan Landvogt',
  TECH_PROVIDER_ADDRESS_STREET: 'Wolfratshauser Str. 137a',
  TECH_PROVIDER_ADDRESS_CITY: '81479 München',
  TECH_PROVIDER_EMAIL: SUPPORT_EMAIL,

  // Support Contact Info (displayed to users)
  SUPPORT_PHONE: PHONE_MAIN,
  SUPPORT_EMAIL,

  // SEPA Direct Debit Info (for payment forms)
  SEPA_CREDITOR_ID: 'DE30ZZZ00000015337',
} as const;
